import React from 'react';
import { Modal } from 'react-router-modal';
import Button from '../../../../Common/DesignSystem/Button';
import Chip from '../../../../Common/DesignSystem/Chips';
import colours from '../../../../Common/DesignSystem/Colours';

import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import { P3Bold, Heading6, P3 } from '../../../../Common/DesignSystem/Text';

const SurveyDetails = (props) => {
    let {details} = props;

    let styles = {
        card: {
            backgroundColor: 'white', 
            padding: 16, 
            borderRadius: 16, 
            boxShadow: '0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08)'
        }
    }

    const renderQuestions = () => {
        var keys = Object.keys(details.data.questions);
        var objects = details.data.questions[keys[0]];
        var data = details.data.questions;

        return (
            keys.map((question_id, index) => {
                let content = data['' + question_id];

                return (
                    <div style={{marginTop: 16, minHeight: 60}} key={question_id}>
                        <P3 style={{color: colours.primary.grey02}}>
                            {content.question}
                        </P3>
                        {
                            content.responses && content.responses.length > 0 ? 
                            content.responses.map((response, index)=> {
                                return (
                                    <div key={index}>
                                        <P3>
                                            {response}
                                        </P3>
                                    </div>
                                )
                            }) : null
                        }
                    </div>
                )
            })
        )
    }

    return (
        <Modal onBackdropClick={props.closeModal}>
            <div className="ds-card">
                <div className="contact-modal-container" style={{maxHeight: '100vh', overflowY: 'auto'}}>
                    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                        <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
                            <div className="modal-header-icon" style={{flex: 1, justifyContent: 'center', paddingLeft: 20}}>
                                <Heading6 style={{textAlign: 'center'}}>
                                    {details.name}
                                </Heading6>
                            </div>
                            <div className="modal-close-icon" onClick={props.closeModal}>
                                <Icon name="Close" size={20} />
                            </div>
                        </div>
                        <div style={{marginTop: 8, display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                            <P3 style={{marginRight: 8}}>
                                Status: 
                            </P3>
                            {details.data.completed_date ? 
                                <Chip custom={{backgroundColor: colours.accent.validate_green, fontColor: '#FFF', label: 'Completed'}}/> : 
                                <Chip type="sent"/>
                            }
                        </div>
                        <div style={{marginTop: 8, display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                            <P3 style={{marginRight: 4}}>
                                Sent: 
                            </P3>
                            <P3Bold>{details.data.created_date}</P3Bold>
                            {
                                details.data.completed_date ?
                                <>
                                    <P3 style={{marginLeft: 16, marginRight: 4}}>
                                        Completed: 
                                    </P3>
                                    <P3Bold>{details.data.completed_date}</P3Bold>
                                </> : null
                            }
                        </div>
                    </div>
                    {renderQuestions()}
                    <div style={{marginTop: 16, minWidth: 172, display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                        <Button secondary large label="Close" onClick={props.closeModal} containerProps={{style: {minWidth: 172}}}/>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default SurveyDetails;